/**
 * MinistrareIA - Video Link Service
 * API service for dynamic video links with view-limit security
 */
import api from './api';
import axios from 'axios';

const BASE = '/api/video-links';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://quora-backend-cl3.kinddesert-624c9557.brazilsouth.azurecontainerapps.io';

class VideoLinkService {
  /** List all video links for the current user */
  async list() {
    const response = await api.get(BASE);
    return response.data;
  }

  /** Get a video link by ID */
  async getById(id) {
    const response = await api.get(`${BASE}/${id}`);
    return response.data;
  }

  /** Create a new video link (upload video + create) */
  async create(file, name, viewLimit = 3, thumbnail = null, onProgress = null) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', name);
    formData.append('view_limit', viewLimit);
    if (thumbnail) {
      formData.append('thumbnail', thumbnail);
    }

    const response = await api.post(BASE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000, // 5 min for large videos
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      },
    });
    return response.data;
  }

  /** Update a video link (name, view_limit) */
  async update(id, data) {
    const response = await api.put(`${BASE}/${id}`, data);
    return response.data;
  }

  /** Delete a video link */
  async delete(id) {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  }

  /** Get view records for a video link */
  async getViews(id) {
    const response = await api.get(`${BASE}/${id}/views`);
    return response.data;
  }

  /** Reset (delete) a specific view record */
  async resetView(videoId, viewId) {
    const response = await api.delete(`${BASE}/${videoId}/views/${viewId}`);
    return response.data;
  }

  // ============================================
  // PUBLIC METHODS (no auth token needed)
  // ============================================

  /** Get public video data (for video player page) */
  async getPublicVideo(videoId, leadId = null) {
    const path = leadId
      ? `${API_BASE_URL}${BASE}/public/${videoId}/${leadId}`
      : `${API_BASE_URL}${BASE}/public/${videoId}`;
    const response = await axios.get(path);
    return response.data;
  }

  /** Record a view on a public video */
  async recordView(videoId, viewerIdentifier, viewerType = 'device', leadId = null) {
    const response = await axios.post(`${API_BASE_URL}${BASE}/public/${videoId}/view`, {
      viewer_identifier: viewerIdentifier,
      viewer_type: viewerType,
      lead_id: leadId,
    });
    return response.data;
  }
}

const videoLinkService = new VideoLinkService();
export default videoLinkService;
